export const getHandoutUploadPayload = async (file) => {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Unable to read the selected file."));
    reader.readAsDataURL(file);
  });

  if (typeof dataUrl !== "string") {
    throw new Error("Unable to process the selected file.");
  }

  const base64Data = dataUrl.split(",")[1];

  if (!base64Data) {
    throw new Error("Unable to process the selected file.");
  }

  return {
    base64Data,
    contentType: file.type,
    fileName: file.name,
  };
};
